(function () {
  function copyText(value) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(value);
    }

    var input = document.createElement('textarea');
    input.value = value;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();

    try {
      document.execCommand('copy');
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    } finally {
      document.body.removeChild(input);
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-copy-code]');
    if (!button) return;

    var code = button.dataset.copyCode;
    var originalText = button.dataset.originalText || button.textContent;
    button.dataset.originalText = originalText;

    copyText(code).then(function () {
      button.textContent = 'Copied';
      button.classList.add('is-copied');

      window.setTimeout(function () {
        button.textContent = originalText;
        button.classList.remove('is-copied');
      }, 1800);
    });
  });
})();
